import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import autoBind from 'auto-bind'
/** Material-UI imports section */
import { Translate } from 'react-localize-redux'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Grid from '@material-ui/core/Grid'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import OptionsIcon from '@material-ui/icons/LineStyle'
import Button from '@material-ui/core/Button'
import Select from 'react-select'

import LoadingPage from '../../common/LoadingPage'
import Toaster from '../../common/Toaster'

/** Import actions */

import {
	GetReleaseLevel,
	GetAllTimeToEntryDeliveryOrder,
	GetRampsFromRelease,
	GetResearchColorOptions,
} from '../../../store/helpers/SelectOptions'
import {
	loadAdvanceOptionsSupplier,
	updateAdvanceOptionsSupplier,
	loadPartnership,
	updatePartnershipSupplier,
	loadAllSupplierTypes,
} from '../../../store/suppliers/SupplierActions'
import { getSupplierTypesOptions } from '../../../store/helpers/SelectOptions'
import { canBeModuleExpeditByCompany } from '../../../store/helpers/RolesHelper'
import { converListToArray } from '../../../store/helpers/ListHelper'
import AdvancedOptionsPTM from '../common/AdvancedOptionsPTM'

/**
 * Component to show general information supplier
 */
class AdvancedOptions extends Component {
	/**
	 * Creates an instance of View.
	 * @param {*} props
	 * @memberof View
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			showToaster: false,
			toasterMessage: null,
			toasterVariant: '',
			supplierTypes: [],
			supplier: {
				release_level: '0',
				sorter: false,
				scales: false,
				is_online_products_supplier: false,
				is_contractor_supplier: false,
				is_custom_broker_supplier: false,
				is_supplier_to_evaluate: false,
				is_maquila_supplier: false,
				rating_type: '0',
				is_active_module_planning_fersa: false,
				access_patio_storage_windows: false,
			},
			partnership: {
				is_inspection_free: false,
				is_carrier: false,
				off_set_delivery_days: 0,
				days_required_for_delivery_material: 0,
				time_hours_required_for_delivery_material: 0,
				is_automotive_supplier: false,
				number_ppms_by_supplier: 0,
				number_ramps: 2,
				is_requiered_quality_certificate: false,
				is_requiered_cerificate_by_template: false,
				is_supplier_to_add_carbon_foot_print: false,
				month_confirm: 0,
				is_plant_access_blocked: false,
				blockingReason: '',
				research: 0,
			},
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		let supplierCode = this.props.supplierCode
		this.props.loadAdvanceOptionsSupplier(supplierCode).then(() => {
			this.setState({
				supplier: { ...this.props.advanceOptionsSupplier },
			})
		})
		/// loadPartnership
		let companyToken = this.props.selectedCompany.token
		this.props.loadPartnership(supplierCode, companyToken).then(() => {
			this.setState({
				partnership: { ...this.props.partnership },
			})
		})
		this.props.loadAllSupplierTypes().then((resultSuppliers) => {
			this.setState({
				supplierTypes: getSupplierTypesOptions(resultSuppliers),
			})
		})
	}

	/**
	 * On change document type
	 *
	 * @param {*} option
	 * @memberof DocumentTypeSelect
	 */
	onChangeDocumentType(option) {
		let updatedSupplier = { ...this.state.supplier }
		updatedSupplier['release_level'] = option.value
		this.setState({
			supplier: updatedSupplier,
		})
	}

	/**
	 * Update the property
	 *
	 * @param {*} user
	 * @param {*} value
	 * @memberof View
	 */
	updateProperty(property, value) {
		let updatedSupplier = { ...this.state.supplier }
		updatedSupplier[property] = value
		this.setState({
			supplier: updatedSupplier,
		})
	}

	/**
	 * Action to save supplier
	 */
	onSaveAdvanceOption() {
		let supplierCode = this.props.supplierCode
		this.props
			.updateAdvanceOptionsSupplier(this.state.supplier, supplierCode)
			.then(() => {
				this.setState({
					showToView: true,
					showToaster: true,
					toasterMessage: <Translate id='common.saveCorrectly' />,
					toasterVariant: 'success',
				})
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	/**
	 * On change TimeToEntryDeliveryOrder
	 *
	 * @param {*} option
	 * @memberof TimeToEntryDeliveryOrder
	 */
	onChangeTimeToEntryDeliveryOrder(option) {
		let updatedPartnership = { ...this.state.partnership }
		updatedPartnership['time_hours_required_for_delivery_material'] = option.value
		this.setState({
			partnership: updatedPartnership,
		})
	}

	/**
	 * on change researche option
	 * @param {*} option
	 */
	onChangeResearchOption(option) {
		let updatePartnership = { ...this.state.partnership }
		updatePartnership['research'] = option.value
		this.setState({
			partnership: updatePartnership,
		})
	}

	/**
	 * On change TimeToEntryDeliveryOrder
	 *
	 * @param {*} option
	 * @memberof TimeToEntryDeliveryOrder
	 */
	onChangeSupplierType(option) {
		let updatedPartnership = { ...this.state.partnership }
		updatedPartnership['supplier_type'] = option.value
		this.setState({
			partnership: updatedPartnership,
		})
	}

	/**
	 * On change number_ramps
	 *
	 * @param {*} option
	 * @memberof number_ramps
	 */
	onChangeNumberRampsDeliveryOrder(option) {
		let updatedPartnership = { ...this.state.partnership }
		updatedPartnership['number_ramps'] = option.value
		this.setState({
			partnership: updatedPartnership,
		})
	}

	onChangeMonthConfirmDeliveryOrder(option) {
		let updatedMonthConfirm = { ...this.state.partnership }
		updatedMonthConfirm['month_confirm'] = option.value
		this.setState({
			partnership: updatedMonthConfirm,
		})
	}

	onChangeRatingType(option) {
		let updatedSupplier = { ...this.state.supplier }
		updatedSupplier['rating_type'] = option.value
		this.setState({
			supplier: updatedSupplier,
		})
	}

	/**
	 * Update partnership the property
	 *
	 * @param {*} user
	 * @param {*} value
	 * @memberof View
	 */
	updatePartnershipProperty(property, value) {
		let updatedPartnership = { ...this.state.partnership }
		updatedPartnership[property] = value
		this.setState({
			partnership: updatedPartnership,
		})
	}

	/**
	 * Action to save Partnership data
	 */
	onSavePartnershipData() {
		let supplierCode = this.props.supplierCode
		if (!this.canBeSaveBlockAccesPlant())
			this.setState({
				showToaster: true,
				toasterMessage: <Translate id='suppliers.messageBlock' />,
				toasterVariant: 'error',
			})
		else {
			this.props
				.updatePartnershipSupplier(this.state.partnership, supplierCode, this.props.selectedCompany.id)
				.then(() => {
					this.setState({
						showToView: true,
						showToaster: true,
						toasterMessage: <Translate id='common.saveCorrectly' />,
						toasterVariant: 'success',
					})
				})
				.catch(() => {
					this.setState({
						showToaster: true,
						toasterMessage: <Translate id='common.errorToSave' />,
						toasterVariant: 'error',
					})
				})
		}
	}

	canBeSaveBlockAccesPlant() {
		if (this.state.partnership.is_plant_access_blocked) {
			if (this.state.partnership.blockingReason !== '' && this.state.partnership.blockingReason !== null)
				return true
			else return false
		} else return true
	}

	/**
	 * Render
	 *
	 * @returns
	 * @memberof AdvancedOptions
	 */
	render() {
		const { classes } = this.props
		let options = GetReleaseLevel()
		let timeDeliveryMateril = GetAllTimeToEntryDeliveryOrder()
		let numberRamps = GetRampsFromRelease()
		let researchOptions = GetResearchColorOptions()
		if (
			this.props.advanceOptionsSupplier === null &&
			this.state.supplier === null &&
			this.props.partnership === null
		) {
			return <LoadingPage />
		} else {
			let supplier = this.state.supplier
			console.log('🚀 ~ file: AdvancedOptions.js:327 ~ AdvancedOptions ~ render ~ supplier:', supplier)
			let partnership = this.state.partnership
			let existSupplierType = this.state.supplierTypes.find((x) => x.value === partnership.supplier_type)
			return (
				<Grid container spacing={24} justify='space-between'>
					<Grid item xs={4}>
						<form noValidate autoComplete='off'>
							<List className={classes.root}>
								<ListItem alignItems='flex-start'>
									<OptionsIcon />
									<ListItemText secondary={<Translate id='suppliers.options' />} />
								</ListItem>
								<ListItem alignItems='flex-start'>
									<ListItemText
										primary={<Translate id='suppliers.releaseLevel' />}
										secondary={
											<Select
												value={options[supplier.release_level]}
												className={classes.documentTypeSelect}
												options={options}
												onChange={this.onChangeDocumentType}
											/>
										}
									/>
								</ListItem>
								<ListItem alignItems='flex-start'>
									<ListItemText
										primary={
											<React.Fragment>
												<FormControlLabel
													control={
														<Checkbox
															onChange={(event) => {
																this.updateProperty('sorter', event.target.checked)
															}}
															color='primary'
															value='status'
															checked={supplier.sorter}
														/>
													}
													label={<Translate id='suppliers.isSupplierSorter' />}
												/>
												<FormControlLabel
													control={
														<Checkbox
															onChange={(event) => {
																this.updateProperty('scales', event.target.checked)
															}}
															color='primary'
															value='status'
															checked={supplier.scales}
														/>
													}
													label={<Translate id='suppliers.enableScales' />}
												/>
												<FormControlLabel
													control={
														<Checkbox
															onChange={(event) => {
																this.updateProperty(
																	'is_online_products_supplier',
																	event.target.checked
																)
															}}
															color='primary'
															value='status'
															checked={supplier.is_online_products_supplier}
														/>
													}
													label={<Translate id='suppliers.rmiInternal' />}
												/>
												{
													<FormControlLabel
														control={
															<Checkbox
																onChange={(event) => {
																	this.updateProperty(
																		'is_supplier_to_evaluate',
																		event.target.checked
																	)
																}}
																color='primary'
																value='status'
																checked={supplier.is_supplier_to_evaluate}
															/>
														}
														label={<Translate id='suppliers.isSupplierToEvaluate' />}
													/>
												}
												<FormControlLabel
													control={
														<Checkbox
															onChange={(event) => {
																this.updateProperty(
																	'is_contractor_supplier',
																	event.target.checked
																)
															}}
															color='primary'
															value='status'
															checked={supplier.is_contractor_supplier}
														/>
													}
													label={<Translate id='suppliers.isContractorSupplier' />}
												/>
												<FormControlLabel
													control={
														<Checkbox
															onChange={(event) => {
																this.updateProperty(
																	'access_patio_storage_windows',
																	event.target.checked
																)
															}}
															color='primary'
															value='status'
															checked={supplier.access_patio_storage_windows}
														/>
													}
													label={<Translate id='suppliers.hasAccessToPatioStorageWindows' />}
												/>
											</React.Fragment>
										}
									/>
								</ListItem>
							</List>
							<Button
								style={{ marginLeft: '16px' }}
								data-cy='btn-saves'
								type='button'
								variant='outlined'
								color='secondary'
								onClick={() => {
									this.onSaveAdvanceOption()
								}}
								disabled={this.props.isSaving}
							>
								{<Translate id='common.save' />}
							</Button>
							<br />
							<br />
						</form>
					</Grid>

					<Grid item xs={8}>
						<form noValidate autoComplete='off'>
							<AdvancedOptionsPTM
								classes={this.classes}
								canBeModuleExpeditByCompany={canBeModuleExpeditByCompany}
								onChangeSupplierType={this.onChangeSupplierType}
								existSupplierType={existSupplierType}
								researchOptions={researchOptions}
								onChangeTimeToEntryDeliveryOrder={this.onChangeTimeToEntryDeliveryOrder}
								partnership={partnership}
								updatePartnershipProperty={this.updatePartnershipProperty}
								onChangeNumberRampsDeliveryOrder={this.onChangeNumberRampsDeliveryOrder}
								numberRamps={numberRamps}
								timeDeliveryMateril={timeDeliveryMateril}
								supplierTypes={this.state.supplierTypes}
								userRolesByCompany={this.props.userRolesByCompany}
								onChangeResearchOption={this.onChangeResearchOption}
							/>
							<br />
							<Button
								style={{ marginLeft: '16px' }}
								data-cy='btn-save'
								type='button'
								variant='outlined'
								color='secondary'
								onClick={() => {
									this.onSavePartnershipData()
									this.onSaveAdvanceOption()
								}}
								disabled={this.props.isSaving}
							>
								{<Translate id='common.save' />}
							</Button>
						</form>
						<br />
						<br />
					</Grid>
					<Toaster
						message={this.state.toasterMessage}
						open={this.state.showToaster}
						variant={this.state.toasterVariant}
						onClose={() => {
							this.setState({ showToaster: false })
						}}
					/>
				</Grid>
			)
		}
	}
}

/**
 * Map state to props mapStateToProps
 * @param {*} state
 */
function mapStateToProps(state) {
	let userRolesByCompany = state.profile.get('userRolesByCompany')
	return {
		supplier: state.suppliers.get('supplier') ? state.suppliers.get('supplier').toJS() : null,
		supplierTypes: state.suppliers.get('supplierTypes') ? state.suppliers.get('supplierTypes').toJS() : null,
		advanceOptionsSupplier: state.suppliers.get('advanceOptionsSupplier')
			? state.suppliers.get('advanceOptionsSupplier').toJS()
			: null,
		isSaving: state.suppliers.get('isSaving'),
		userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
	}
}

/**
 * mapDispatchToProps
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadAdvanceOptionsSupplier: (token) => {
			return dispatch(loadAdvanceOptionsSupplier(token))
		},
		updateAdvanceOptionsSupplier: (supplier, code) => {
			return dispatch(updateAdvanceOptionsSupplier(supplier, code))
		},
		loadPartnership: (supplierCode, companyToken) => {
			return dispatch(loadPartnership(supplierCode, companyToken))
		},
		updatePartnershipSupplier: (partnership, supplierCode, companyId) => {
			return dispatch(updatePartnershipSupplier(partnership, supplierCode, companyId))
		},
		loadAllSupplierTypes: () => {
			return dispatch(loadAllSupplierTypes())
		},
	}
}

const viewStyles = (theme) => ({
	edit: {
		marginRight: 30,
		backgroundColor: theme.palette.text.hint,
	},
	root: {
		flexGrow: 1,
	},
	inline: {
		display: 'inline',
	},
	imagenSize: {
		margin: 50,
		width: 1090,
		height: 420,
		marginLeft: 80,
	},
	formControl: {},
	toolbar: {},
	searchInput: {},
	button: {},
	actionsToolbar: {},
	showingUsersCounter: {},
	grow: {},
	supplierBadge: {},
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingLeft: '100px',
		paddingRight: '150px',
	},
	styleTab: {
		backgroundColor: '#fff',
	},
	avatar: {
		backgroundColor: theme.palette.secondary.main,
		marginLeft: 10,
		margin: 10,
		width: 60,
		height: 60,
	},
	logoFileInput: {
		display: 'none',
	},
	flexEnd: {
		display: 'flex',
		marginTop: '7px',
	},
	margin: {
		marginTop: '15px',
	},
	color: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
})

export default withRouter(
	withStyles(viewStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(AdvancedOptions))
)
